import Alpine from "alpinejs";
import mixitup from "mixitup";

Alpine.data("mixitup", () => ({
    init() {
        const container = this.$refs.container || this.$root;
        this.mixer = mixitup(container, {
            callbacks: {
                onMixStart: function (state, futureState) {
                    futureState.hide.forEach((item) => item.removeAttribute("data-mix"));
                    futureState.show.forEach((item, index) => item.setAttribute("data-mix", index + 1));
                },
            },
        });
    },
}));
